module.exports = __webpack_public_path__ + "static/pic07-538485df65e307c1ac5b1652464d56b0.jpg";